import { useMemo, useRef } from 'react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import reports from 'modules/reports/store/collections/reports'
import type Report from 'modules/reports/store/models/Report'

interface Props {
  id: string
  loading: boolean
  onReportFound?: (model: Report) => void
}
interface ReturnType {
  isNotFound: boolean
  report: Report | null | undefined
  backUrl: string
}

const useReport = ({ id, loading, onReportFound }: Props): ReturnType => {
  const { navigation } = useNavigation()

  const backUrl = useRef('')

  const report = useMemo(() => {
    if (loading) return null

    const model = reports.get(id)

    if (!model) return null

    if (onReportFound) onReportFound(model)

    backUrl.current = navigation.reports.dashboards.dashboardId.list.fullPath({
      dashboard_id: model.dashboardId,
    })

    return model
  }, [onReportFound, id, loading, backUrl])

  return {
    report,
    backUrl: backUrl.current,
    isNotFound: !loading && !report,
  }
}

export default useReport
